export const VIEWS = {
    YOUR_ACCOUNT : 'yourAccount',
    CHANGE_SECURITY_QUESTIONS : 'changeSecurityQuestions',
    CHANGE_PASSWORD : 'changePassword',
    EMAIL_PREFERENCES : 'emailPreferences',
    EDIT_CONTACT_INFO : 'editContactInfo'
};
